export class GetRestoreTemplateResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreTemplate",
            "baseName": "restoreTemplate",
            "type": "RestoreTemplate",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetRestoreTemplateResponse.attributeTypeMap;
    }
    constructor() {
    }
}
